"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_token_1 = require("./awsui-token");
var TokenGroupWrapper = /** @class */ (function (_super) {
    __extends(TokenGroupWrapper, _super);
    function TokenGroupWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TokenGroupWrapper.prototype.findTokens = function () {
        return this.findAll('.awsui-token').map(function (tokenElement) { return new awsui_token_1.default(tokenElement.getElement()); });
    };
    /**
     * Returns a token from the group for a given index.
     *
     * @param tokenIndex 1-based index of the token to return.
     */
    TokenGroupWrapper.prototype.findToken = function (tokenIndex) {
        return new awsui_token_1.default(this.find(".awsui-token:nth-child(" + tokenIndex + ")").getElement());
    };
    return TokenGroupWrapper;
}(dom_1.ComponentWrapper));
exports.default = TokenGroupWrapper;
//# sourceMappingURL=awsui-token-group.js.map